import { render, staticRenderFns } from "./List-OrderDetail.vue?vue&type=template&id=0b37556c&scoped=true"
import script from "./List-OrderDetail.vue?vue&type=script&lang=js"
export * from "./List-OrderDetail.vue?vue&type=script&lang=js"
import style0 from "./List-OrderDetail.vue?vue&type=style&index=0&id=0b37556c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b37556c",
  null
  
)

export default component.exports